import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { Observable, from } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.blockly.editor';
import { AccountService } from './_services/account.service';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  version: string = environment.version;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private accountService: AccountService,
    public router: Router,
    public menu: MenuController
  ) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
      }
    });
  }

  ngOnInit(): void {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    const meta = this.renderer.createElement('meta');
    this.renderer.setAttribute(meta, 'name', 'viewport');
    this.renderer.setAttribute(
      meta,
      'content',
      isSafari
        ? 'width=device-width, initial-scale=1, viewport-fit=cover'
        : 'width=device-width, initial-scale=1'
    );
    this.renderer.appendChild(this.document.head, meta)
    this.accountService.init().subscribe();
  }
}
